import Cookies from "js-cookie";
import store from "@/store";
import {
  PAGE_DETAILS,
  PAGE_PERSONAL,
  PAGE_HOME,
  PAGE_REGISTER,
  PAGE_REGISTRATION_ENDS,
  isLogin,
} from "./constant";
import i18n from "@/i18n";
export const isPC = () => {
  var userAgentInfo = navigator.userAgent;
  var Agents = [
    "Android",
    "iPhone",
    "SymbianOS",
    "Windows Phone",
    "iPad",
    "iPod",
  ];
  var flag = true;
  for (var v = 0; v < Agents.length; v++) {
    if (userAgentInfo.indexOf(Agents[v]) > 0) {
      flag = false;
      break;
    }
  }
  return flag;
};
export const handleJumpPage = (type, area) => {
  const userInfo = store.state.userInfo ||window.location.pathname.split("/")[2]|| {};
  const site = area ? area : userInfo.countryCode || "global";
  const baseUrl = `${process.env.VUE_APP_SERVICE_API}/poprun/${site}/`;
  window.location.href = baseUrl + type;
};

export const setBury = (event, data, baseData) => {
  const IS_CONSENT_ANALYSIS_COOKIE = Cookies.get("notice_gdpr_prefs")
    ? Cookies.get("notice_gdpr_prefs").match(/3/)
    : false;
  if (IS_CONSENT_ANALYSIS_COOKIE) {
    const gtag = window.gtag;
    if (!gtag) return;
    if (process.env.NODE_ENV !== "production") {
      console.log("ga bury data: ", event, data);
    }
    gtag("set", "user_properties", baseData);
    gtag("event", event, data);
  }
};

export const getPageMapParams = (path) => {
  const type = path.split("/")[2];
  const site = path.split("/")[1];
  const PAGE_STACK = JSON.parse(sessionStorage.getItem("PAGE_STACK")) || [];
  const source_location =
    PAGE_STACK.length > 0 ? PAGE_STACK[0] : "out_community";
  switch (type) {
    case PAGE_HOME:
      return {
        user_level: "",
        source_location,
        page: "/index.html",
        page_type: "poprun_home",
        tipB: "49",
        tipC: "0",
        tipD: "0",
        tipE: "30231",
        tip: "1222.49.0.0.30231",
      };
    case PAGE_DETAILS:
      return {
        user_level: "",
        source_location,
        page: "/details.html",
        page_type: "poprun_details",
        tipB: "50",
        tipC: "0",
        tipD: "0",
        tipE: "30234",
        tip: "1222.50.0.0.30234",
      };
    case PAGE_REGISTER:
      return {
        user_level: "",
        source_location,
        page: "/register.html",
        page_type: "poprun_register",
        tipB: "51",
        tipC: "0",
        tipD: "0",
        tipE: "30239",
        tip: "1222.51.0.0.30239",
      };

    case PAGE_REGISTRATION_ENDS:
      return {
        user_level: "",
        source_location,
        page: "/registerEnd.html",
        page_type: "poprun_success",
        tipB: "58",
        tipC: "0",
        tipD: "1",
        tipE: "36257",
        tip: "1222.58.0.1.36257",
      };
    case PAGE_PERSONAL:
      return {
        user_level: "",
        source_location,
        page: "/personal.html",
        page_type: "poprun_personalpage",
        tipB: "59",
        tipC: "0",
        tipD: "1",
        tipE: "36258",
        tip: "1222.59.0.1.36258",
      };

    default:
      return {};
  }
};
export const getClickMapParams = (
  type,
  { open_url, open_page, button_name },
  tipD
) => {
  const PAGE_STACK = JSON.parse(sessionStorage.getItem("PAGE_STACK")) || [];
  const source_location =
    PAGE_STACK.length > 0 ? PAGE_STACK[0] : "out_community";
  const baseParam = {
    user_mid: isLogin,
    platform: isPC() ? "pc" : "m",
    site: i18n.locale,
  };
  let data = {};
  switch (type) {
    // 点击_run now
    case "home_enter":
      data = {
        page: "/index.html",
        page_type: "poprun_home",
        tipB: "49",
        tipC: "1",
        tipD: "1",
        tipE: "30233",
        tip: "1222.49.1.1.30233",
        source_location,
        open_url,
        open_page,
        button_name,
        module_name: "enter",
      };
      break;
    // 点击_PC顶栏官网入口
    case "home_header":
      data = {
        page: "/index.html",
        page_type: "poprun_home",
        tipB: "49",
        tipC: "4",
        tipD: "1",
        tipE: "36354",
        tip: "1222.49.4.1.36354",
        source_location,
        open_url,
        open_page,
        button_name,
        module_name: "header",
      };
      break;
    // 点击_个人主页
    case "home_personalcenter":
      data = {
        page: "/index.html",
        page_type: "poprun_home",
        tipB: "49",
        tipC: "3",
        tipD: "1",
        tipE: "36254",
        tip: "1222.49.3.1.36254",
        source_location,
        open_url,
        open_page,
        button_name,
        module_name: "personalcenter",
      };
      break;
    // 点击_专业赛报名按钮
    case "details_professional_register":
      data = {
        page: "/details.html",
        page_type: "poprun_details",
        tipB: "50",
        tipC: "2",
        tipD,
        tipE: "30237",
        tip: `1222.50.2.${tipD}.30237`,
        source_location,
        open_url,
        open_page,
        button_name,
        module_name: "professional_register",
      };
      break;
    // 点击_娱乐赛报名按钮
    case "details_amateur_register":
      data = {
        page: "/details.html",
        page_type: "poprun_details",
        tipB: "50",
        tipC: "3",
        tipD,
        tipE: "30237",
        tip: `1222.50.3.${tipD}.30238`,
        source_location,
        open_url,
        open_page,
        button_name,
        module_name: "amateur_register",
      };
      break;
    // 点击_PC顶栏官网入口
    case "details_header":
      data = {
        page: "/details.html",
        page_type: "poprun_details",
        tipB: "50",
        tipC: "5",
        tipD: "1",
        tipE: "36355",
        tip: "1222.50.5.1.36355",
        source_location,
        open_url,
        open_page,
        button_name,
        module_name: "header",
      };
      break;
    // 点击_提前报名弹窗_确认按钮
    case "details_early_enroll_pop":
      data = {
        page: "/register.html",
        page_type: "poprun_register",
        tipB: "50",
        tipC: "4",
        tipD,
        tipE: "36256",
        tip: `1222.50.4.${tipD}.36256`,
        source_location,
        open_url,
        open_page,
        button_name,
        module_name: "early_enroll_pop",
      };
      break;
    // 点击_PC顶栏官网入口
    case "register_header":
      data = {
        page: "/register.html",
        page_type: "poprun_register",
        tipB: "51",
        tipC: "2",
        tipD: "1",
        tipE: "36356",
        tip: "1222.51.2.1.36356",
        source_location,
        open_url,
        open_page,
        button_name,
        module_name: "header",
      };
      break;
    // 点击_提交按钮
    case "register_submit":
      data = {
        page: "/register.html",
        page_type: "poprun_register",
        tipB: "51",
        tipC: "1",
        tipD: "1",
        tipE: "30240",
        tip: "1222.51.1.1.30240",
        source_location,
        open_url,
        open_page,
        button_name,
        module_name: "submit",
      };
      break;
    // 点击_PC顶栏官网入口
    case "success_header":
      data = {
        page: "/registerEnd.html",
        page_type: "poprun_success",
        tipB: "",
        tipC: "",
        tipD: "",
        tipE: "",
        tip: "",
        source_location,
        open_url,
        open_page,
        button_name,
        module_name: "header",
      };
      break;
    // 点击_商城广告入口（M端是个人主页广告入口；PC为顶栏常驻跳转入口）
    case "personalpage_ad_mall":
      data = {
        page: "/personal.html",
        page_type: "poprun_personalpage",
        tipB: "58",
        tipC: "1",
        tipD: "1",
        tipE: "36357",
        tip: "1222.58.1.1.36357",
        source_location,
        open_url,
        open_page,
        button_name,
        module_name: "ad_mall",
      };
      break;
    // 点击_下载按钮
    case "personalpage_download":
      data = {
        page: "/personal.html",
        page_type: "poprun_personalpage",
        tipB: "59",
        tipC: "1",
        tipD: "1",
        tipE: "36260",
        tip: "1222.59.1.1.36260",
        source_location,
        open_url,
        open_page,
        button_name,
        module_name: "download",
      };
      break;
    // 点击_分享按钮
    case "personalpage_share":
      data = {
        page: "/personal.html",
        page_type: "poprun_personalpage",
        tipB: "59",
        tipC: "2",
        tipD,
        tipE: "36261",
        tip: `1222.59.2.${tipD}.36261`,
        source_location,
        open_url,
        open_page,
        button_name,
        module_name: "share",
      };
      break;
    // 点击_PC顶栏官网入口
    case "personalpage_header":
      data = {
        page: "/personal.html",
        page_type: "poprun_personalpage",
        tipB: "59",
        tipC: "5",
        tipD: "1",
        tipE: "36358",
        tip: "1222.59.5.1.36358",
        source_location,
        open_url,
        open_page,
        button_name,
        module_name: "header",
      };
      break;
    // 点击_RunNow按钮
    case "personalpage_runnow":
      data = {
        page: "/personal.html",
        page_type: "poprun_personalpage",
        tipB: "59",
        tipC: "4",
        tipD: "1",
        tipE: "36353",
        tip: "1222.59.4.1.36353",
        source_location,
        open_url,
        open_page,
        button_name,
        module_name: "runnow",
      };
      break;
    default:
      break;
  }
  setBury("click", data, baseParam);
};

export const getExposeMapParams = (type, tipD) => {
  const PAGE_STACK = JSON.parse(sessionStorage.getItem("PAGE_STACK")) || [];
  const source_location =
    PAGE_STACK.length > 0 ? PAGE_STACK[0] : "out_community";
  const baseParam = {
    user_mid: isLogin,
    platform: isPC() ? "pc" : "m",
    site: i18n.locale,
  };
  let data = {};
  switch (type) {
    // 曝光_国家城市面板
    case "home_choose_region_pop":
      data = {
        page: "/index.html",
        page_type: "poprun_home",
        tipB: "49",
        tipC: "2",
        tipD,
        tipE: "30232",
        tip: `1222.49.2.${tipD}.30232`,
        module_name: "choose_region_pop",
        source_location,
      };
      break;
    // 曝光_活动详情弹窗
    case "details_introduction_pop":
      data = {
        page: "/details.html",
        page_type: "poprun_details",
        tipB: "50",
        tipC: "1",
        tipD: "1",
        tipE: "30235",
        tip: `1222.50.1.1.30235`,
        module_name: "Introduction_pop",
        source_location,
      };
      break;
    // 曝光_提前报名弹窗
    case "details_early_enroll_pop":
      data = {
        page: "/details.html",
        page_type: "poprun_details",
        tipB: "50",
        tipC: "4",
        tipD: "1",
        tipE: "36255",
        tip: `1222.50.4.1.36255`,
        module_name: "early_enroll_pop",
        source_location,
      };
      break;
    // 曝光_商城广告入口（仅M端）
    case "personalpage_ad_mall":
      data = {
        page: "/personal.html",
        page_type: "poprun_personalpage",
        tipB: "59",
        tipC: "1",
        tipD: "1",
        tipE: "36259",
        tip: `1222.59.1.1.36259`,
        module_name: "ad_mall",
        source_location,
      };
      break;
    default:
      break;
  }
  setBury("expose", data, baseParam);
};
